import BrandTable from "./components/BrandTable";

export default function Index() {
  return (
    <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
      <main className="text-sm text-gray-500">
        <BrandTable />
      </main>
    </div>
  );
}